var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"close",attrs:{"color":"secondary","fab":"","x-small":"","dark":""},on:{"click":function($event){return _vm.$emit('action')}}},[_c('v-icon',[_vm._v("close")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }